<div
    class="c_pagination"
    *ngIf="totalPages > 0"
    style="
        margin-top: 15px;
        display: flex;
        align-items: center;
        justify-content: space-between;
    "
>
    <nav>
        <ul class="pagination pagination-sm mb-0">
            <li class="page-item" [class.disabled]="currentPage === 1">
                <a class="page-link" (click)="changePage(currentPage - 1)">
                    {{ "PREVIOUS" | translate }}
                </a>
            </li>

            <li
                class="page-item"
                *ngFor="let p of getDisplayedPages()"
                [class.active]="p === currentPage"
                [class.disabled]="p === '...'"
            >
                <a
                    class="page-link"
                    *ngIf="p !== '...'"
                    (click)="changePage(p)"
                >
                    {{ p }}
                </a>
                <span
                    class="page-link"
                    style="pointer-events: none; color: black"
                    *ngIf="p === '...'"
                >
                    ...</span
                >
            </li>

            <li class="page-item" [class.disabled]="currentPage === totalPages">
                <a class="page-link" (click)="changePage(currentPage + 1)">
                    {{ "NEXT" | translate }}
                </a>
            </li>
        </ul>
    </nav>
    <div>
        <label class="text-muted small" style="margin-inline-end: 5px">
            {{ "ITEM_PER_PAGE" | translate }}
        </label>
        <select
            class="form-select form-select-sm w-auto d-inline"
            [(ngModel)]="itemPerPage"
            (ngModelChange)="changeItemsPerPage($event)"
        >
            <option *ngFor="let n of perPagesList" [value]="n">{{ n }}</option>
        </select>
    </div>
</div>
